const info = {
    $schema: '../assetlist.schema.json',
    chain_name: 'stargaze',
    assets: [
        {
            description: 'Stargaze is a decentralized blockchain platform designed specifically for non-fungible tokens (NFTs), enabling creators to mint, trade, and interact with NFTs in a fully decentralized environment.',
            extended_description: 'Stargaze is an innovative platform in the Cosmos ecosystem focused on NFTs. It provides a decentralized space where creators can mint, trade, and manage their NFTs with ease. The platform\'s decentralized nature ensures that creators retain full control over their digital assets, enhancing security and ownership rights. Stargaze\'s user-friendly interface and robust infrastructure make it an ideal choice for artists and collectors looking to engage with NFTs in a decentralized manner.',
            denom_units: [{
                    denom: 'ustars',
                    exponent: 0
                }, {
                    denom: 'stars',
                    exponent: 6
                }],
            base: 'ustars',
            name: 'Stargaze',
            display: 'stars',
            symbol: 'STARS',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg'
            },
            coingecko_id: 'stargaze',
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/stars.svg',
                    theme: {
                        primary_color_hex: '#db2777'
                    }
                }],
            socials: {
                website: 'https://www.stargaze.zone/',
                twitter: 'https://twitter.com/StargazeZone'
            },
            type_asset: 'sdk.coin'
        },
        {
            description: 'The native token of ohhNFT.',
            denom_units: [{
                    denom: 'factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/dust',
                    exponent: 0
                }, {
                    denom: 'strdst',
                    exponent: 6
                }],
            base: 'factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/dust',
            name: 'Stardust STRDST',
            display: 'strdst',
            symbol: 'STRDST',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.svg'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/dust.svg',
                    theme: {
                        primary_color_hex: '#c9720c'
                    }
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'The native meme token of stargaze.',
            denom_units: [{
                    denom: 'factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/mGAZE',
                    exponent: 0
                }, {
                    denom: 'GAZE',
                    exponent: 6
                }],
            base: 'factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/mGAZE',
            name: 'Gaze GAZE',
            display: 'GAZE',
            symbol: 'GAZE',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/gaze.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/gaze.svg'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/gaze.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/gaze.svg',
                    theme: {
                        primary_color_hex: '#b3a584'
                    }
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'ohhNFT LP token.',
            denom_units: [{
                    denom: 'factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uBRNCH',
                    exponent: 0
                }, {
                    denom: 'BRNCH',
                    exponent: 6
                }],
            base: 'factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uBRNCH',
            name: 'Branch',
            display: 'BRNCH',
            symbol: 'BRNCH',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.svg'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/brnch.svg',
                    theme: {
                        primary_color_hex: '#70372a'
                    }
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'Social token for the ohhVAULT.',
            denom_units: [{
                    denom: 'factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uOHH',
                    exponent: 0
                }, {
                    denom: 'OHH',
                    exponent: 6
                }],
            base: 'factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uOHH',
            name: 'ohhVAULT ohh',
            display: 'OHH',
            symbol: 'OHH',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/ohh.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/ohh.svg'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/ohh.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/ohh.svg',
                    theme: {
                        primary_color_hex: '#dcc0c2'
                    }
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'The native coin of Sneaky Productions.',
            denom_units: [{
                    denom: 'factory/stars1xx5976njvxpl9n4v8huvff6cudhx7yuu8e7rt4/usneaky',
                    exponent: 0
                }, {
                    denom: 'sneaky',
                    exponent: 6
                }],
            base: 'factory/stars1xx5976njvxpl9n4v8huvff6cudhx7yuu8e7rt4/usneaky',
            name: 'Sneaky Productions',
            display: 'sneaky',
            symbol: 'SNEAKY',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.svg'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/sneaky.svg',
                    theme: {
                        primary_color_hex: '#fbcaca'
                    }
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'LAB - Everything is an Experiment',
            extended_description: 'LAB - Everything is an Experiment\n\nUse 10 $LAB tokens to mint 1 Mad Scientist NFT on Backbone Labs Osmosis Launchpad. You will then be able to trade your NFTs on the marketplace. You can also choose to hold onto your $LAB tokens as unrevealed NFTs and trade it.\n\n Fair Launch: The event was marked by the absence of whitelists (WLs), no bots and no lock, ensuring an equitable opportunity for all interested parties.\n\nPreparation for the Launch: Participants were given a 52.91-hour window to deposit $OSMO into a pool on Streamswap.\n\nThe Swap Process: After the initial deposit period, $OSMO was converted into $LAB tokens over an additional hour, allowing for a smooth transition and fair distribution.',
            denom_units: [{
                    denom: 'ibc/93B1AE0AD5E88242745B245064A2A51DDA1319C18176A966D5F8F9E02ED5373E',
                    exponent: 0
                }, {
                    denom: 'LAB',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/93B1AE0AD5E88242745B245064A2A51DDA1319C18176A966D5F8F9E02ED5373E',
            name: 'LAB',
            display: 'LAB',
            symbol: 'LAB',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/LAB.png'
            },
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo17fel472lgzs87ekt9dvk0zqyh5gl80sqp4sk4n/LAB',
                        channel_id: 'channel-75'
                    },
                    chain: {
                        channel_id: 'channel-0',
                        path: 'transfer/channel-0/factory/osmo17fel472lgzs87ekt9dvk0zqyh5gl80sqp4sk4n/LAB'
                    }
                }],
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/LAB.png',
                    image_sync: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo17fel472lgzs87ekt9dvk0zqyh5gl80sqp4sk4n/LAB'
                    },
                    theme: {
                        primary_color_hex: '#bcdd76'
                    }
                }],
            coingecko_id: 'mad-scientists'
        },
        {
            description: 'CDT - Membrane\'s solvency preserving stablecoin',
            denom_units: [{
                    denom: 'ibc/B0263C28B6F44651F4596413B41FDB749EA010BD1220816DAC0ABF9947C1E806',
                    exponent: 0
                }, {
                    denom: 'CDT',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/B0263C28B6F44651F4596413B41FDB749EA010BD1220816DAC0ABF9947C1E806',
            name: 'CDT',
            display: 'CDT',
            symbol: 'CDT',
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/ucdt',
                        channel_id: 'channel-75'
                    },
                    chain: {
                        channel_id: 'channel-0',
                        path: 'transfer/channel-0/factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/ucdt'
                    }
                }],
            images: [{
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/CDT.svg',
                    image_sync: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/ucdt'
                    }
                }],
            coingecko_id: 'collateralized-debt-token'
        },
        {
            description: 'MBRN - Membrane\'s network token',
            denom_units: [{
                    denom: 'ibc/E94BB144B818CB8061F43E202BEA1E9273B87D6326C8C6F4E6AE71C62FD37854',
                    exponent: 0
                }, {
                    denom: 'MBRN',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/E94BB144B818CB8061F43E202BEA1E9273B87D6326C8C6F4E6AE71C62FD37854',
            name: 'MBRN',
            display: 'MBRN',
            symbol: 'MBRN',
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/umbrn',
                        channel_id: 'channel-75'
                    },
                    chain: {
                        channel_id: 'channel-0',
                        path: 'transfer/channel-0/factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/umbrn'
                    }
                }],
            images: [{
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/MBRN.svg',
                    image_sync: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/umbrn'
                    }
                }],
            coingecko_id: 'membrane'
        },
        {
            description: 'Astroport is a neutral marketplace where anyone, from anywhere in the galaxy, can dock to trade their wares.',
            denom_units: [{
                    denom: 'ibc/C9C8D88917374F27F03CBCEAF4F1B85F45A62F9F2316CBAADAAC5FDB3675DD3F',
                    exponent: 0,
                    aliases: ['uastro']
                }, {
                    denom: 'astro',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/C9C8D88917374F27F03CBCEAF4F1B85F45A62F9F2316CBAADAAC5FDB3675DD3F',
            name: 'Astroport token',
            display: 'astro',
            symbol: 'ASTRO',
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'neutron',
                        base_denom: 'factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro',
                        channel_id: 'channel-18'
                    },
                    chain: {
                        channel_id: 'channel-191',
                        path: 'transfer/channel-191/factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro'
                    }
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg'
            },
            images: [{
                    image_sync: {
                        chain_name: 'neutron',
                        base_denom: 'factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro'
                    },
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/neutron/images/astro.svg',
                    theme: {
                        primary_color_hex: '#4056e9'
                    }
                }],
            coingecko_id: 'astroport-fi'
        },
        {
            description: 'PLEB',
            denom_units: [{
                    denom: 'factory/stars1k7qsxdxh8calmt4txk75e6hdntefslegwddqnlwjjqgjkmcfqy0qa97sn8/pleb',
                    exponent: 0
                }, {
                    denom: 'PLEB',
                    exponent: 6
                }],
            base: 'factory/stars1k7qsxdxh8calmt4txk75e6hdntefslegwddqnlwjjqgjkmcfqy0qa97sn8/pleb',
            name: 'PLEB',
            display: 'PLEB',
            symbol: 'PLEB',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/pleb.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/pleb.png'
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'KINGSHIT',
            denom_units: [{
                    denom: 'factory/stars133a6mnkp9d3pkt48y699hy0tvq5xngpz7cwak0qr4suq0cj9zpfslvt0em/kingshit',
                    exponent: 0
                }, {
                    denom: 'KINGSHIT',
                    exponent: 6
                }],
            base: 'factory/stars133a6mnkp9d3pkt48y699hy0tvq5xngpz7cwak0qr4suq0cj9zpfslvt0em/kingshit',
            name: 'KINGSHIT',
            display: 'KINGSHIT',
            symbol: 'KINGSHIT',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/kingshit.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/kingshit.png'
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'BOTZ',
            denom_units: [{
                    denom: 'factory/stars132jrwxjps93usq3ejy7cq6qqc7j3gtx3mu8jhaj5nnk3p0ste2ssqsndvj/botz',
                    exponent: 0
                }, {
                    denom: 'BOTZ',
                    exponent: 6
                }],
            base: 'factory/stars132jrwxjps93usq3ejy7cq6qqc7j3gtx3mu8jhaj5nnk3p0ste2ssqsndvj/botz',
            name: 'BOTZ',
            display: 'BOTZ',
            symbol: 'BOTZ',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/botz.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/botz.png'
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'COCKS',
            denom_units: [{
                    denom: 'factory/stars14mfk0sd6rlajkvgpgrvfk9lfhjwmkrzvednekvcn32jzy3drjy5sfem9p7/cocks',
                    exponent: 0
                }, {
                    denom: 'COCKS',
                    exponent: 6
                }],
            base: 'factory/stars14mfk0sd6rlajkvgpgrvfk9lfhjwmkrzvednekvcn32jzy3drjy5sfem9p7/cocks',
            name: 'COCKS',
            display: 'COCKS',
            symbol: 'COCKS',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/cocks.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/cocks.png'
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'The Representative factory token for Trump Kemistry',
            denom_units: [{
                    denom: 'ibc/4982C47384F003FCCB02490F92CE2F23DBEC9A7A0C1F440BDB12D24357E6703D',
                    exponent: 0
                }, {
                    denom: 'XTRUMP',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/4982C47384F003FCCB02490F92CE2F23DBEC9A7A0C1F440BDB12D24357E6703D',
            name: 'XTRUMP',
            display: 'XTRUMP',
            symbol: 'XTRUMP',
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP',
                        channel_id: 'channel-75'
                    },
                    chain: {
                        channel_id: 'channel-0',
                        path: 'transfer/channel-0/factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP'
                    }
                }],
            images: [{
                    image_sync: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP'
                    },
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/XTRUMP.png',
                    theme: {
                        primary_color_hex: '#b02b27'
                    }
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/XTRUMP.png'
            }
        },
        {
            description: 'WOLFSHIT',
            denom_units: [{
                    denom: 'factory/stars167y92c2fe690l0lrqyk9tahpqvu97au0cmpayh3j9455r2f6f06s78emw4/wolfshit',
                    exponent: 0
                }, {
                    denom: 'WOLFSHIT',
                    exponent: 6
                }],
            base: 'factory/stars167y92c2fe690l0lrqyk9tahpqvu97au0cmpayh3j9455r2f6f06s78emw4/wolfshit',
            name: 'WOLFSHIT',
            display: 'WOLFSHIT',
            symbol: 'WOLFSHIT',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/wolfshit.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/wolfshit.png'
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'Native token of the Underworld.',
            denom_units: [{
                    denom: 'factory/stars1t6fyr84hn6lyjdvk3e3c697cptfn5cwat2jxqyzuvuesaypznslshy6x9v/vlt',
                    exponent: 0
                }, {
                    denom: 'VLT',
                    exponent: 6
                }],
            base: 'factory/stars1t6fyr84hn6lyjdvk3e3c697cptfn5cwat2jxqyzuvuesaypznslshy6x9v/vlt',
            name: 'VLT',
            display: 'VLT',
            symbol: 'VAULT',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/vault.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/vault.png'
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'OLD Bonded GopLend STARS',
            extended_description: 'OLD | bglSTARS (Bonded GopLend STARS) is issued in exchange for STARS for the deposit period. These tokens are liquid and generate income in the amount of the set APR on the platform',
            denom_units: [{
                    denom: 'factory/stars1ur79p98rmpn456esgzjernaxy7v25mlwqsv8uhymzxahfw77427syk2h9j/bglSTARS',
                    exponent: 0
                }, {
                    denom: 'OLDbglSTARS',
                    exponent: 6
                }],
            base: 'factory/stars1ur79p98rmpn456esgzjernaxy7v25mlwqsv8uhymzxahfw77427syk2h9j/bglSTARS',
            name: 'OLDbglSTARS',
            display: 'OLDbglSTARS',
            symbol: 'OLDbglSTARS',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/bglSTARS.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/bglSTARS.png'
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'OLD Bonded GopLend USDC',
            extended_description: 'OLD | bglUSDC (Bonded GopLend USDC) is issued in exchange for USDC for the deposit period. These tokens are liquid and generate income in the amount of the set APR on the platform',
            denom_units: [{
                    denom: 'factory/stars1ur79p98rmpn456esgzjernaxy7v25mlwqsv8uhymzxahfw77427syk2h9j/bglUSDC',
                    exponent: 0
                }, {
                    denom: 'OLDbglUSDC',
                    exponent: 6
                }],
            base: 'factory/stars1ur79p98rmpn456esgzjernaxy7v25mlwqsv8uhymzxahfw77427syk2h9j/bglUSDC',
            name: 'OLDbglUSDC',
            display: 'OLDbglUSDC',
            symbol: 'OLDbglUSDC',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/bglUSDC.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/bglUSDC.png'
                }],
            type_asset: 'sdk.coin'
        },
        {
            description: 'The Cosmos Network\'s premier self-hatred memecoin.',
            extended_description: 'Shitmos is a fair launched token deployed via the start.cooking liquidity bootstrapping protocol (LBP) on the Osmosis blockchain. It is powered by the Shitmos Economic Zone (SEZ), and it has been designed with the goal of uniting the Cosmos Network and interchain-at-large ecosystems by making crypto fun. The SEZ is a federation of nft collections on Stargaze that supports Shitmos by providing at least 2% of royalties towards open market purchases of Shitmos.',
            denom_units: [{
                    denom: 'ibc/8577E98BDDD2758FD5647A53563DAAC89921326F964EBF899B945ED05A66CA5F',
                    exponent: 0
                }, {
                    denom: 'SHITMOS',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/8577E98BDDD2758FD5647A53563DAAC89921326F964EBF899B945ED05A66CA5F',
            name: 'Shitmos',
            display: 'SHITMOS',
            symbol: 'SHITMOS',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.svg'
            },
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/shitmos',
                        channel_id: 'channel-75'
                    },
                    chain: {
                        channel_id: 'channel-0',
                        path: 'transfer/channel-0/factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/shitmos'
                    }
                }],
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.png',
                    image_sync: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/shitmos'
                    },
                    theme: {
                        primary_color_hex: '#639BFF',
                        circle: true
                    },
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/shitmos.svg'
                }]
        },
        {
            description: 'GATA Yield DAO Governance Token',
            extended_description: 'GATA Yield DAO is a decentralized, community-governed organization focused on sustainable yield generation and resource allocation. Governed by YGATA stakers, GATA Yield DAO is committed to long-term value growth and to support aligned projects in Cosmos/IBC, with decisions made through open and verifiable governance. Designed for equitable participation, GATA Yield DAO prioritizes community benefits and financial sustainability.',
            denom_units: [{
                    denom: 'ibc/2A56F95E2B74AB769816403D384E2199C7BC510BFD2F8352FAC6DF0294B83EBA',
                    exponent: 0
                }, {
                    denom: 'ygata',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/2A56F95E2B74AB769816403D384E2199C7BC510BFD2F8352FAC6DF0294B83EBA',
            name: 'Yield GATA',
            display: 'ygata',
            symbol: 'YGATA',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/ygata.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/ygata.svg'
            },
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'omniflixhub',
                        base_denom: 'factory/omniflix1fwphj5p6qd8gtkehkzfgac38eur4uqzgz97uwvf6hsc0vjl004gqfj0xnv/ygata',
                        channel_id: 'channel-49'
                    },
                    chain: {
                        channel_id: 'channel-398',
                        path: 'transfer/channel-398/factory/omniflix1fwphj5p6qd8gtkehkzfgac38eur4uqzgz97uwvf6hsc0vjl004gqfj0xnv/ygata'
                    }
                }],
            images: [{
                    image_sync: {
                        chain_name: 'omniflixhub',
                        base_denom: 'factory/omniflix1fwphj5p6qd8gtkehkzfgac38eur4uqzgz97uwvf6hsc0vjl004gqfj0xnv/ygata'
                    },
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/ygata.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/omniflixhub/images/ygata.svg',
                    theme: {
                        primary_color_hex: '#7b5aff'
                    }
                }],
            socials: {
                website: 'https://gatahub.zone',
                twitter: 'https://x.com/GataHubZone'
            }
        },
        {
            description: 'The token of Crowdpunk DAO',
            denom_units: [{
                    denom: 'ibc/D29FF5FFE7B9A5C6CE595FF963F7C93F2B8603586645C39B13E1D336847863C3',
                    exponent: 0,
                    aliases: ['erc20/0xfbF4318d24a93753F11d365A6dcF8b830e98Ab0F']
                }, {
                    denom: 'crowdp',
                    exponent: 18
                }],
            type_asset: 'ics20',
            base: 'ibc/D29FF5FFE7B9A5C6CE595FF963F7C93F2B8603586645C39B13E1D336847863C3',
            name: 'Crowdpunk DAO',
            display: 'crowdp',
            symbol: 'CROWDP',
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'evmos',
                        base_denom: 'erc20/0xfbF4318d24a93753F11d365A6dcF8b830e98Ab0F',
                        channel_id: 'channel-13'
                    },
                    chain: {
                        channel_id: 'channel-46',
                        path: 'transfer/channel-46/erc20/0xfbF4318d24a93753F11d365A6dcF8b830e98Ab0F'
                    }
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.svg'
            },
            images: [{
                    image_sync: {
                        chain_name: 'evmos',
                        base_denom: 'erc20/0xfbF4318d24a93753F11d365A6dcF8b830e98Ab0F'
                    },
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/evmos/images/crowdp.svg',
                    theme: {
                        primary_color_hex: '#04fbfb'
                    }
                }]
        },
        {
            description: 'CULT - Less Brainwashing, More Utility',
            extended_description: 'CULT - Less Brainwashing, More Utility\n\n$CULT is more than a token; it\'s your key to ascend within the Order of Architects. Each token empowers you to mint and upgrade Architect NFTs, navigating through rites that elevate their mystical powers. Engage directly in our unique Streamswap process, beginning with a USDC deposit, transitioning smoothly into $CULT.\n\nFair Launch: Our token launch excludes whitelists and bots, ensuring a transparent and equitable distribution for all. Streamswap Mechanics: Deposit $USDC during the 72-hour Bootstrapping Phase, followed by a 1-hour Streaming Phase to convert into $CULT, ensuring a smooth and fair token distribution.',
            denom_units: [{
                    denom: 'ibc/1CD4EED1BD74D41C165B9200AAF7A13C92DDB381DB7067EA32EEF8CC1370F764',
                    exponent: 0,
                    aliases: ['ucult']
                }, {
                    denom: 'CULT',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/1CD4EED1BD74D41C165B9200AAF7A13C92DDB381DB7067EA32EEF8CC1370F764',
            name: 'CULT',
            display: 'CULT',
            symbol: 'CULT',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/cult.png'
            },
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1qdvwftqd8ml6t9w6dmj97m03ck5ghqqmd8y7cm/cult',
                        channel_id: 'channel-75'
                    },
                    chain: {
                        channel_id: 'channel-0',
                        path: 'transfer/channel-0/factory/osmo1qdvwftqd8ml6t9w6dmj97m03ck5ghqqmd8y7cm/cult'
                    }
                }],
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/cult.png',
                    image_sync: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1qdvwftqd8ml6t9w6dmj97m03ck5ghqqmd8y7cm/cult'
                    }
                }]
        },
        {
            description: 'The native token of MANTRA',
            denom_units: [{
                    denom: 'ibc/3BD86E80E000B52DA57C474A6A44E37F73D34E38A1FA79EE678E08D119FC555B',
                    exponent: 0,
                    aliases: ['uom']
                }, {
                    denom: 'om',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/3BD86E80E000B52DA57C474A6A44E37F73D34E38A1FA79EE678E08D119FC555B',
            name: 'MANTRA',
            display: 'om',
            symbol: 'OM',
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'mantrachain',
                        base_denom: 'uom',
                        channel_id: 'channel-4'
                    },
                    chain: {
                        channel_id: 'channel-406',
                        path: 'transfer/channel-406/uom'
                    }
                }],
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-Prim-Col.png',
                svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-Prim-Col.svg'
            },
            images: [
                {
                    image_sync: {
                        chain_name: 'mantrachain',
                        base_denom: 'uom'
                    },
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-Prim-Col.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-Prim-Col.svg',
                    theme: {
                        circle: true,
                        primary_color_hex: '#fba0c1'
                    }
                },
                {
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-Darkmatt.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-Darkmatt.svg',
                    theme: {
                        dark_mode: true,
                        circle: true,
                        primary_color_hex: '#342c2c'
                    }
                },
                {
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-WHT.png',
                    svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/OM-WHT.svg',
                    theme: {
                        dark_mode: false,
                        circle: true,
                        primary_color_hex: '#342c2c'
                    }
                }
            ],
            coingecko_id: 'mantra-dao'
        },
        {
            description: 'The community token for The Fortunate Few, a multi chain NFT community platform.',
            extended_description: 'HOOD is the community token for The Fortunate Few, a multi-chain NFT community platform and DAO, with its genesis collection available on the Stargaze marketplace. The community interfaces with other NFT collections and communities, including Hooded Syndicate, Jack-O-Hoods and Hoods of Christmas NFT collections. The project also contributed collaboration NFTS on The Cosmic Gumball Machine NFT collection and Wolfhunters, also on Stargaze. Join the ranks of The Fortunate Few and learn more in the official Discord channel here: https://discord.gg/HDRNRTUTXC',
            denom_units: [{
                    denom: 'factory/stars1rru5m2wh3fylpheqh8h5g968jwhe7rctkfm7u0gwk7ka4vx3q5tqukjl4z/hood',
                    exponent: 0
                }, {
                    denom: 'HOOD',
                    exponent: 6
                }],
            base: 'factory/stars1rru5m2wh3fylpheqh8h5g968jwhe7rctkfm7u0gwk7ka4vx3q5tqukjl4z/hood',
            name: 'HOOD',
            display: 'HOOD',
            symbol: 'HOOD',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/hood.png'
            },
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/stargaze/images/hood.png'
                }],
            socials: {
                website: 'https://ffsc.site',
                twitter: 'https://x.com/FortunateFewNFT'
            },
            type_asset: 'sdk.coin'
        },
        {
            description: 'The OG meme coin on MANTRA Chain',
            extended_description: 'ex-Wall Street banker turned crypto kingpin. Ali now rides with his OMies representing his biker gang, cruising towards RWA glory on his pink EV motorcycle.',
            denom_units: [{
                    denom: 'ibc/8A443E18BB2C30A0D635569935BB0364018EA97A372ADA5D7145378A40D3D967',
                    exponent: 0
                }, {
                    denom: 'bike',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/8A443E18BB2C30A0D635569935BB0364018EA97A372ADA5D7145378A40D3D967',
            name: 'Ali-Rev-Gator',
            display: 'bike',
            symbol: 'BIKE',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/BIKE.png'
            },
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'mantrachain',
                        base_denom: 'factory/mantra1vtpg8z82gz9qe3adf7t9z0qwuvkpzmqu9ds4ej/BIKE',
                        channel_id: 'channel-4'
                    },
                    chain: {
                        channel_id: 'channel-406',
                        path: 'transfer/channel-406/factory/mantra1vtpg8z82gz9qe3adf7t9z0qwuvkpzmqu9ds4ej/BIKE'
                    }
                }],
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/mantrachain/images/BIKE.png',
                    image_sync: {
                        chain_name: 'mantrachain',
                        base_denom: 'factory/mantra1vtpg8z82gz9qe3adf7t9z0qwuvkpzmqu9ds4ej/BIKE'
                    },
                    theme: {
                        primary_color_hex: '#80c75d',
                        circle: true
                    }
                }]
        },
        {
            description: 'T7S is the heartbeat of the Seven Shaders universe—powering NFTs, AI adventures, and gaming rewards. One token, endless possibilities.',
            extended_description: 'T7S is more than just a token—it\'s the driving force behind the Seven Shaders ecosystem, bringing together NFTs, AI-powered experiences, and gaming rewards into one interconnected universe. Whether you\'re an explorer, creator, or strategist, T7S unlocks new dimensions of engagement and rewards. \n\nWith T7S, you can mint and upgrade exclusive NFTs, immersing yourself in a world where rarity and utility go hand in hand. Gamers and strategists can earn and trade rewards through Oddsgarden.io, while AI enthusiasts can embark on intelligent adventures shaped by cutting-edge technology. \n\nThe token also plays a pivotal role in governance through DAODAO, allowing the community to actively shape the future of Seven Shaders. As the ecosystem expands, T7S continues to evolve, introducing new staking opportunities, enhanced rewards, and interactive experiences that push the boundaries of Web3 engagement. \n\nWhether you\'re here to collect, compete, or create, T7S ensures that every interaction brings value, making it your ultimate gateway to a universe filled with limitless potential.',
            denom_units: [{
                    denom: 'ibc/FEF6B2D5C0F7D3C3EE2E27D1C01EAE9CA04A7201661E69215726E7F84AFCD0FB',
                    exponent: 0
                }, {
                    denom: 'T7S',
                    exponent: 6
                }],
            type_asset: 'ics20',
            base: 'ibc/FEF6B2D5C0F7D3C3EE2E27D1C01EAE9CA04A7201661E69215726E7F84AFCD0FB',
            name: 'The seven green shade',
            display: 'T7S',
            symbol: 'T7S',
            logo_URIs: {
                png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/T7S.png'
            },
            traces: [{
                    type: 'ibc',
                    counterparty: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/t7s',
                        channel_id: 'channel-75'
                    },
                    chain: {
                        channel_id: 'channel-0',
                        path: 'transfer/channel-0/factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/t7s'
                    }
                }],
            images: [{
                    png: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/osmosis/images/T7S.png',
                    image_sync: {
                        chain_name: 'osmosis',
                        base_denom: 'factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/t7s'
                    }
                }]
        }
    ]
};
export default info;
